import { ReactNode } from 'react';
import { IconType } from '../icon/helpers';

export type GridCard = {
  id: string;
  IconEl?: ReactNode;
  children?: ReactNode;
  iconId?: IconType;
  title?: string;
  detail?: string;
  onClick?: () => void;
  categoryId?: string;
};

export type GridCardCategory = {
  title: string;
  id: string;
};

export type CardSize = 'small' | 'large';

export const CARD_SIZES: Record<CardSize, { width: number; height: number }> = {
  small: { width: 372, height: 96 },
  large: { width: 212, height: 262 },
};
